import FormSection from '..';
import CareerFormSidebar from '../Sidebars/Career';
import { CTAForm } from 'components/Form/CTAForm';

const CareerForm = () => (
    <FormSection sidebar={<CareerFormSidebar />}>
        <CTAForm isCareerPage />
    </FormSection>
);

export default CareerForm;
